import React from "react";

function UpdateScoreModal({
 selectedGame,
 scoreForm,
 handleScoreChange,
 handleUpdateScore,
 setIsScoreModalOpen,
 getTeamNameById,
}) {
 return (
  <div className="game-schedule-modal-overlay">
   <div className="game-schedule-modal-content">
    <h3>Update Score</h3>

    <form onSubmit={handleUpdateScore}>
     <label>
      {getTeamNameById(selectedGame.team1_id)}
      <input
       type="number"
       name="score_team1"
       value={scoreForm.score_team1}
       onChange={handleScoreChange}
       required
      />
     </label>

     <label>
      {getTeamNameById(selectedGame.team2_id)}
      <input
       type="number"
       name="score_team2"
       value={scoreForm.score_team2}
       onChange={handleScoreChange}
       required
      />
     </label>

     <button type="submit">Update</button>

     <button type="button" onClick={() => setIsScoreModalOpen(false)}>
      Cancel
     </button>
    </form>
   </div>
  </div>
 );
}

export default UpdateScoreModal;